import { coreService } from 'network-utils';
import { useQuery } from 'react-query';

export const getReports = 'reports';
export const getReportsStatus = 'reports-status';
export const getReportStatus = 'report-status';

export const useGetReports = (token: string, isEnabled: boolean, options: any) => {
    const { search, limit, offset, source, fromDate, toDate, sort } = options;
    return useQuery(
        [getReports, token, limit, offset, source, fromDate, toDate, search, sort],
        () =>
            coreService.reportsApi.getReports(token, {
                search,
                limit,
                offset,
                source,
                fromDate,
                toDate,
                sort
            }),
        {
            keepPreviousData: true,
            cacheTime: 0,
            enabled: !!token && isEnabled
        }
    );
};

export const useGetReportsStatus = (token: string, isActive: boolean, intervalMS: number) => {
    return useQuery([getReportsStatus, token], () => coreService.reportsApi.getReportsStatus(token), {
        keepPreviousData: false,
        cacheTime: 0,
        enabled: !!token && isActive,
        refetchInterval: intervalMS
    });
};

export const useGetReportStatus = (token: string, reportJobId: number) => {
    return useQuery(
        [getReportStatus, token, reportJobId],
        () => coreService.reportsApi.getReportStatus(token, reportJobId),
        {
            keepPreviousData: true,
            cacheTime: 0,
            enabled: !!token && !!reportJobId,
            refetchInterval: 2000
        }
    );
};
